import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { DealerLoggerDto, DealerMenuItemDto } from '@core/dtos'
import { DealerHttp, GameHttp } from '@core/https'
import { AccountService } from '@core/services'
import { MenuCardComponent } from '@src/app/inbetween/rush-components/rush-content/classic/menu/menu-card/menu-card.component'
import { LoggerPanelComponent } from '../../logger-panel/logger-panel.component'
import { RushGameHttp } from '@rush-core/https'
import { AllLiveMessagesDto } from '@rush-core/dtos/all-live-messages.dto'
import { LiveMessageTypeEnum } from '@rush-shared/enums'
import { LiveMessageModel } from '@rush-shared/models'
import { LiveMessagesComponent } from '@rush-shared/components'

@Component({
  selector: 'app-logger-classic-menu',
  standalone: true,
  imports: [
    LiveMessagesComponent,
    CommonModule,
    RouterModule,
    MenuCardComponent,
    LoggerPanelComponent,
  ],
  providers: [DealerHttp],
  templateUrl: './logger-classic-menu.component.html',
  styleUrl: './logger-classic-menu.component.sass',
})
export class LoggerClassicMenuComponent implements OnInit, AfterViewInit {
  constructor(
    private _dealerHttp: DealerHttp,
    private _gameHttp: GameHttp,
    private _accountService: AccountService,
    private _rushGameHttp: RushGameHttp,
  ) {
    this.isSmallScreen = window.innerWidth <= 768
  }

  dealers: DealerMenuItemDto[] = []
  private readonly loggerId = this._accountService.currentUserId
  showLoggerPanel: boolean = false
  selectedDealerId: string
  isSmallScreen: boolean
  messages: LiveMessageModel[] = []
  liveMessageTypeEnum = LiveMessageTypeEnum

  ngOnInit(): void {
    this.loadDealers()

    this._rushGameHttp.getLiveMessages(LiveMessageTypeEnum.CLASSIC).subscribe((messages) => {
      this.messages = messages
    })
  }

  trackByDealer(index: number, dealer: DealerMenuItemDto) {
    return dealer.id
  }

  ngAfterViewInit() {
    this._dealerHttp.getDealerLogger(this.loggerId).subscribe((dealerLogger) => {
      // if (dealerLogger) {
      //   this.selectedDealerId = dealerLogger.dealerId

      //   this.showLoggerPanel = true
      // }
      this.selectedDealerId = dealerLogger.dealerId

      this.showLoggerPanel = true
    })
  }

  loadDealers() {
    this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
      this.dealers = i.dealerMenuItems.filter((dealer) => {
        if (!dealer.dealerLogger) {
          return true
        }

        return dealer.dealerLogger.hasLogger !== true
      })
    })
  }

  async updateDealerTable(dealerId: string) {
    const data = {
      hasLogger: true,
      loggerId: this.loggerId,
      dealerId,
    } as DealerLoggerDto

    await this._dealerHttp.updateDealerLogger(data)
    // this._router.navigate(['logger', dealerId])
    this.showLoggerPanel = true
    this.selectedDealerId = dealerId
  }

  async backToMenu(): Promise<void> {
    const data = {
      hasLogger: false,
      loggerId: null,
      dealerId: this.selectedDealerId,
    } as DealerLoggerDto

    await this._dealerHttp.updateDealerLogger(data)

    this.showLoggerPanel = false
    this.selectedDealerId = ''

    this.loadDealers()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 768
  }
}
